<template>
  <div class="relative m-4 ms-0 hidden w-full justify-center overflow-hidden lg:flex">
    <article class="absolute inset-0 z-10 m-auto h-fit w-2/3 max-w-[700px] space-y-10 p-0 text-white">
      <img
        :src="Graphic"
        alt=""
      >
      <div>
        <div class="mb-6 flex w-full items-center justify-center gap-2">
          <div class="flex h-6 w-12 items-center justify-center rounded bg-[#E3BCD4] text-sm font-semibold uppercase tracking-tight text-[oklch(21%_0.034_264.665)]">
            new
          </div>
          <!-- eslint-disable-next-line spectre/prefer-spectre-text -- custom/branding typography ("text-sm font-semibold tracking-tight text-white") outside the design-system scale -->
          <p class="text-sm font-semibold tracking-tight text-white">
            Lettings Prospecting
          </p>
        </div>
        <!-- eslint-disable-next-line spectre/prefer-spectre-heading -- custom/branding typography ("mx-auto w-fit text-xl font-bold leading-9 tracking-tight text-white") outside the design-system scale -->
        <h2 class="mx-auto w-fit text-xl font-bold leading-9 tracking-tight text-white">
          Your new competitive edge in landlord prospecting.
        </h2>
        <SpectreText
          class="mt-4 text-center"
          size="lg"
          color="muted"
        >
          Unrivalled data, powerful Al and omni-channel marketing, all in one platform to grow your lettings portfolio, faster.
        </SpectreText>
      </div>
    </article>
    <img
      class="size-full self-end rounded-xl object-cover object-top"
      :src="Background"
      alt=""
    >
  </div>
</template>

<script setup lang="ts">
import { SpectreText } from '@agentsoftware/spectre-ui';
import Background from '../../../images/auth/Lettings-Prospecting-Background.png';
import Graphic from '../../../images/auth/Lettings-prospecting-hero.png';
</script>
